import React from 'react';

import { Box, Button, Flex, Icon, icons } from '@tapresearch/ui/components';

import { Buttons } from 'Shared/Button';
import Link from '../../../common/Link';

export const ActionButtons = ({ projectIdentifier }) => {
  return (
    <Box mb={{ base: 4, sm: 0 }}>
      <Flex justify="flex-end">
        <Link
          to={`/insights_platform/projects/${projectIdentifier}/data_export`}
          external={true}
        >
          <Button
            {...Buttons.PrimarySmall}
            mr={4}
            rightIcon={<Icon icon={icons.fi.Download} />}
          >
            Download
          </Button>
        </Link>
      </Flex>
    </Box>
  );
};
